import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://94bd1ad259968a62ab5ff200f6ddbdb7@o4510147688988672.ingest.us.sentry.io/4510147802365952",
  sendDefaultPii: true
});
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
